document.addEventListener('DOMContentLoaded', function load() {
     /* setTimeout(function(){ 
      	addToCartModal();
      }, 1500);
   */
  
  if (window.location.href.indexOf("greeting-cards") > -1) {
           
    setTimeout(function(){
         $('.span4').removeClass('pw_category_block');
    }, 50);

   setTimeout(function(){
      $("body").addClass("pw_cards_page");
     $(".span4").addClass("custom_pw_tile");
    }, 100);
  }
  
  // called when user returns from Printzware Modal Window
  function closeDialog() {
      document.ontouchmove = function (e) {
          return true;
      }
      var offset = parseInt($j("body").css('top'), 10);
      var scrollingElement = document.scrollingElement || document.documentElement;
      $j("body").removeClass("modal-open pw-modal-open");
      $j("body").css({'padding-right': '0px'});
      if (typeof pw_disable_scrolltop === 'undefined') {
          $j(window).scrollTop(offset * -1);
      }
      // apply the original viewport
      viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute('content', origViewportString);
      // set iframe to blank page and close
      $j('#pw_iframe').attr('src', 'about:blank');
      $j('#pw_modal').modal('hide');
      $j('#pw_modal').removeClass('in');
      $j('#pw_modal').hide();
      $j('.bootstrap-wrapper .modal-backdrop').remove();
  }

  $(document).on("click", "#pw_modal #pwCancelButton, .bootstrap-wrapper, #pw_modal", function (e) {
            closeDialog();
        });
  
    function addToCartModal(){
          $('.pwAddToCart').removeClass('js-ajax-submit');

        $(".pwAddToCart").on("click", function(e){
		
           e.preventDefault();
          
           $("#cardzware-popup").modal("show");

          $("#cardzware-popup .cls").on("click", function () {
             $("#cardzware-popup").modal("hide");
            
          });

          $("#no-modal").on("click", function () {
                $("#cardzware-popup").modal("hide");

                        var quantity = $(".js-qty-input.quantity").val(); //quantity input value, selector depends on the theme
                        var productVariantID = $('.pwProductSelect').val();
                       
                         var PersonalisationID = $("input[name*='PersonalisationID']").val();
                         var deliveryDate = $("input[name*='Delivery Date']").val();
                          if ($("input[name*='Gift Card']").is(':checked')) {
                             var giftCard = 1;
                          } else{
                            var giftCard = "";
                          }
                       
                        var to = $("input[name*='To']").val();
                        var from = $("input[name*='From']").val();
                       var items = [
                            {
                                quantity: quantity,
                                id: productVariantID,
                                properties: {
                                    'PersonalisationID': PersonalisationID,
                                    'Delivery Date': deliveryDate,
                                    'Gift Card': giftCard,
                                    'To': to,
                                    'From': from
                                    
                                },
                            }
                        ];


                      fetch('/cart/add.js', {
                            method: "post",
                            headers: {'content-type': 'application/json'},
                            body: JSON.stringify({
                                items: items
                            })
                        }).then(() => {
                            window.location.href = '/cart';
                        })
            
                //$("form.product__form-buttons").submit();
          });

          $("#yes-modal").on("click", function () {

              $("#cardzware-popup").modal("hide");
            $("#pw_modal").addClass("greeting_cards_modal");
            
            $("#pw_greeting_card_order").val("");
            $("#pw_greeting_card_product_id").val("");
            if ($(".pw-greeting-card-preview").length) {
                $(".pw-greeting-card-preview").remove();
            }

            var shopifyCardVariantID;
            data = {"func": "shopifyGetClientData"};
            var modalCardURL, confirmURL;
            $.ajax({
                type: 'POST',
                url: window.location.origin + "/a/greeting-cards/index.php",
                data: data,
                crossDomain: true,
                dataType: 'json',
                success: function (json_data, textStatus, jqXHR) {

                    confirmURL = json_data.confirmURL;
                    modalCardURL = urldecode(json_data.modalURL);
                    shopifyCardVariantID = json_data.cardVariantID;

                    pwProductMode = false;
                    opendialog(modalCardURL);
                    var urlParams = new URLSearchParams(modalCardURL);
                    var orderID = urlParams.get('o');


                },
                error: function (json_data, textStatus, errorThrown) {
                    console.log('pw: ERROR get clientID failed, card images will not be changed');
                }
            });

            $j.receiveMessage(function (e) {
               // returnData = JSON.parse('{"' + decodeURI(e.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
                returnData = JSON.parse('{"' + decodeURI(e.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
                console.log(returnData);
                if (returnData.func == "addCard") {

                    setTimeout(function () {

                        var orderID = returnData.yourOrderID;
                        var shopifyCardVariantID = 43142034751669;

                        $("#pw_greeting_card_order").val(orderID);
                        $("#pw_greeting_card_product_id").val(shopifyCardVariantID);

                        var orderID = returnData.yourOrderID;
                        //var shopifyCardVariantID = $("#pw_greeting_card_product_id").val();

                        var quantity = $(".js-qty-input.quantity").val(); //quantity input value, selector depends on the theme
                        var productVariantID = $('.pwProductSelect').val();
                            console.log(quantity);
                        /*var prop_array = [];
                        var properties = $("input[name*='properties']")
                          properties.each(function() {
                
                                var prop_value = $(this).val();
                                var prop_name = $(this).attr("name");
                                prop_name = prop_name.substring(11);
                                prop_name = prop_name.slice(0,-1)
                      
                                if(prop_value){
                                   prop_array[prop_name] = prop_value;
                                }           
                             console.log(prop_array);
                          });
*/
                         var PersonalisationID = $("input[name*='PersonalisationID']").val();
                         var deliveryDate = $("input[name*='Delivery Date']").val();
                          if ($("input[name*='Gift Card']").is(':checked')) {
                             var giftCard = 1;
                          } else{
                            var giftCard = "";
                          }
                       
                        var to = $("input[name*='To']").val();
                        var from = $("input[name*='From']").val();
                      
                        var items = [
                            {
                                id: shopifyCardVariantID,
                                properties: {
                                    'PersonalisationID': orderID
                                },
                                quantity: 1
                            },
                            {
                                quantity: quantity,
                                id: productVariantID,
                                properties: {
                                    'PersonalisationID': PersonalisationID,
                                    'Delivery Date': deliveryDate,
                                    'Gift Card': giftCard,
                                    'To': to,
                                    'From': from
                                    
                                },
                            }
                        ];


                      fetch('/cart/add.js', {
                            method: "post",
                            headers: {'content-type': 'application/json'},
                            body: JSON.stringify({
                                items: items
                            })
                        }).then(() => {
                            window.location.href = confirmURL;
                        })
                     

                       /* 
                        fetch('/cart/add.js', {
                            method: "post",
                            headers: {'content-type': 'application/json'},
                            body: JSON.stringify({
                                items: items
                            })
                        })
                        window.location.href = "/cart";*/
                      
                       /* data = {"func": "shopifySaveThumb", "yourOrderID": orderID};
                        
                        $j.ajax({
                            type: 'POST',
                            url: window.location.origin + "/a/greeting-cards/index.php",
                            data: data,
                            crossDomain: true,
                            dataType: 'json',
                            success: function (json_data, textStatus, jqXHR) {
                                console.log("pw: cart updated(" + orderID + "), thumb saved. reload cart");
                                
                                    window.location.href = "/cart";
                               
                            },
                            error: function (json_data, textStatus, errorThrown) {

                                console.log('pw: thumb save failed');
                            }
                        });*/

                        $("#pw_modal").modal("hide");
                        
                    }, 2000);

                } else if (returnData.func == "cancel") {
                    $("#pw_modal").modal("hide");
                    closeDialog();
                }
             
            });

          });

        });
        
      
    }
  
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($("body").hasClass("template-product") && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($("body").hasClass("template-product") && pw_button.length){
      
      $("body").addClass("pw-product");

      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();

      $(".pwAddToCart").on("click", function(e){
		 setTimeout(function(){ 
        	//location.reload();
            const url = new URL(window.location.href);
            url.searchParams.set('gs_drawer_open', 'true');
            window.location.href = url.toString();
          
        }, 1500);
      });


      function pwVariationChange(){

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".is-selected .product-media-container img").attr("data-src", product_image_original);
              $(".is-selected .product-media-container img").attr("data-bgset", product_image_original);
              $(".is-selected .product-media-container img").attr("src", product_image_original);
              $(".is-selected .product-media-container img").attr("srcset", product_image_original);
            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            
          }
          
          setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();
             
           },500);
        }

      }
      
      $(".product-option .form-check").on("click", function(e){
		
         pwVariationChange();

      });

    }
  	
  	function replacePWimages(){
      
      var textArray = $(".ajax-cart__cart-items .ajax-cart__cart-item .ajax-cart__item-details:contains('PersonalisationID')");

      textArray.each(function() {

        var cardID = this.innerText.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        cardID = cardID.match(/[^\s]+/);
        cardID = cardID[0];
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/504/"+cardID+".jpg?r="+rand;
        $(this).parent().find("img").addClass("pwThumbImage");
        $(this).parent().find("img").attr("src",newSrc);
        $(this).parent().find("img").attr("srcset",newSrc);
        
      });
      
    
    }

  $(".slideout__trigger-mobile-menu.js-mini-cart-trigger.js-slideout-open").on("click", function(e){
     setTimeout(function(){ 
      	replacePWimages();
      }, 3000);
  });


    if ($("body").hasClass("template-cart")){
      
     
      setTimeout(function(){ 
      	replacePWimages();
      }, 3000);
      
      /*$(document).ajaxComplete(function(){
         replacePWimages();
      });*/
      $("#pw_modal").on('hidden.bs.modal', function() { 
          
          setTimeout(function(){ 
              replacePWimages();
          },1000);
      });
  }

}, false);

